import "./ButtonArrow.scss";


function ButtonArrow(props) {

    return(
        <button className={props.classname}
                onClick={props.function}>
            <span>
                <img src={props.src} alt={props.alt}/>
            </span>
        </button>
    )
}

export default ButtonArrow;